import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Loader2, Lock } from "lucide-react";
import { api, apiError, setToken, getToken } from "@/lib/api";
import { Logo } from "@/components/Logo";
import { useSEO } from "@/hooks/useSEO";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  useSEO({ title: "Admin • IND RIL", description: "Restricted." });

  useEffect(() => { if (getToken()) nav("/bossadmin/founder-creators"); }, [nav]);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      const { data } = await api.post("/admin/login", { email, password });
      setToken(data.access_token);
      nav("/bossadmin/founder-creators");
    } catch (err) { setError(apiError(err)); }
    finally { setLoading(false); }
  };

  const inputCls = "w-full rounded-xl border border-white/10 bg-white/5 px-4 py-3 text-white placeholder-white/30 outline-none focus:border-indril-saffron/60";

  return (
    <div className="flex min-h-screen items-center justify-center bg-zinc-950 px-6">
      <div className="pointer-events-none absolute left-1/2 top-1/3 h-72 w-72 -translate-x-1/2 rounded-full bg-indril-saffron/15 blur-[120px]" />
      <motion.form initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} onSubmit={submit}
        className="relative w-full max-w-sm rounded-3xl border border-white/10 bg-white/[0.03] p-8 backdrop-blur-xl" data-testid="admin-login">
        <div className="mb-6 text-center">
          <Logo markClass="h-10 w-10 mx-auto" showWordText={false} />
          <h1 className="mt-4 font-display text-2xl font-semibold text-white">Super Admin</h1>
          <p className="mt-1 flex items-center justify-center gap-1.5 text-xs text-white/40"><Lock className="h-3 w-3" /> Restricted access</p>
        </div>
        <div className="space-y-4">
          <input className={inputCls} type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="admin-email" />
          <input className={inputCls} type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="admin-password" />
          {error && <p className="rounded-lg bg-red-500/10 px-3 py-2 text-sm text-red-300" data-testid="admin-error">{error}</p>}
          <button disabled={loading} className="flex w-full items-center justify-center gap-2 rounded-full bg-indril-saffron px-6 py-3 font-semibold text-zinc-950 disabled:opacity-60" data-testid="admin-login-submit">
            {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : "Sign In"}
          </button>
        </div>
      </motion.form>
    </div>
  );
}
